import Browser from '@wetransfer/transfer/modules/concorde-browser';
import { getFullVariant } from '@wetransfer/transfer/modules/experiments';

/**
 * Part of an experiment for the Transfer Core pod
 * https://wetransfer.atlassian.net/browse/TRA-4508
 */

export default class ExperimentMwebAppInstallBanner {
  static key = 'mweb-app-install-banner-2';

  static variations = {
    control: 'control',
    'receiver-info-view': 'receiver-info-view',
    'download-started-view': 'download-started-view',
  };

  static isControl(): boolean {
    return this.currentVariant() === this.variations.control;
  }

  static isReceiverInfoView(): boolean {
    if (!Browser.isMobile) return false;

    return this.currentVariant() === this.variations['receiver-info-view'];
  }

  static isDownloadStartedView(): boolean {
    if (!Browser.isMobile) return false;

    return this.currentVariant() === this.variations['download-started-view'];
  }

  static currentVariant(): string {
    return getFullVariant(this.key, { value: this.variations.control })
      .value as string;
  }
}
